<ppl-app-container>
  <div class="align-in-center">
    <ppl-box-container-with-header title="Complete Coevera account"
                                   i18n-title="@@Complete_Coevera_account">

      <ppl-error-box *ngIf="error$ | async; let error">
        <ng-container [ngSwitch]="error.error">
          <ng-container *ngSwitchCase="WelcomeError.ERROR_SESSION_EXPIRED"
                        i18n="@@Your_session_expired.">
            Your session expired.
          </ng-container>
          <ng-container *ngSwitchCase="WelcomeError.ERROR_INCORRECT_PASSWORD"
                        i18n="@@Your_old_password_is_invalid.">
            Your old password is invalid.
          </ng-container>
          <ng-container *ngSwitchCase="WelcomeError.ERROR_INVALID_MESSAGE"
                        i18n="@@Invalid_request_data_sent.">
            Invalid request data sent.
          </ng-container>
          <ng-container *ngSwitchCase="WelcomeError.ERROR_INCORRECT_LOGIN"
                        i18n="@@Invalid_password.">
            Invalid password.
          </ng-container>
          <ng-container *ngSwitchCase="WelcomeError.ERROR_TERMS_CONDITIONS_NOT_ACCEPTED"
                        i18n="@@You_did_not_accept_terms_and_conditions.">
            You did not accept terms and conditions.
          </ng-container>
          <ng-container *ngSwitchCase="WelcomeError.ERROR_INVALID_DATA">{{ error.errorStr }} </ng-container>
          <ng-container *ngSwitchDefault>
            <span i18n="@@Unknown_error.">Unknown error.</span>
          </ng-container>
        </ng-container>
      </ppl-error-box>

      <ppl-form-container [formGroup]="form">
        <ppl-form-row>
          <ppl-form-column>
            <ppl-input-container label="Email"
                                 i18n-label="@@Email"
                                 [pplFormControl]="form.get('email')">
              <input pplInput
                     name="email"
                     type="email"
                     autocomplete="username"
                     formControlName="email" />
            </ppl-input-container>
          </ppl-form-column>
        </ppl-form-row>

        <ppl-form-row>
          <ppl-form-column>
            <ppl-input-container label="First name"
                                 i18n-label="@@First_name"
                                 [pplFormControl]="form.get('first_name')">
              <input pplInput
                     name="first_name"
                     autocomplete="given-name"
                     formControlName="first_name" />
            </ppl-input-container>
          </ppl-form-column>
          <ppl-form-column>
            <ppl-input-container label="Last name"
                                 i18n-label="@@Last_name"
                                 [pplFormControl]="form.get('last_name')">
              <input pplInput
                     name="last_name"
                     autocomplete="family-name"
                     formControlName="last_name" />
            </ppl-input-container>
          </ppl-form-column>
        </ppl-form-row>

        <ng-container *ngIf="canChangePassword">
          <ppl-form-row *ngIf="mustChangePassword"
                        formGroupName="passwords">
            <ppl-form-column>
              <ppl-input-container label="Password"
                                   i18n-label="@@Password"
                                   [pplFormControl]="form.get('passwords.password1')">
                <input pplInput
                       type="password"
                       name="password1"
                       autocomplete="new-password"
                       formControlName="password1" />
              </ppl-input-container>
            </ppl-form-column>
            <ppl-form-column>
              <ppl-input-container label="Confirm password"
                                   i18n-label="@@Confirm_password"
                                   [pplFormControl]="form.get('passwords.password2')">
                <input pplInput
                       type="password"
                       name="password2"
                       autocomplete="new-password"
                       formControlName="password2" />
              </ppl-input-container>
            </ppl-form-column>
          </ppl-form-row>
          <ppl-password-change *ngIf="!mustChangePassword"
                               [form]="form.get('passwords')"
                               [canChangePassword]="canChangePassword"
                               [enabled]="changePassword"
                               (changePassword)="onToggleChangePassword()"></ppl-password-change>
        </ng-container>

        <ppl-form-row>
          <ppl-form-column>
            <ppl-input-container [pplFormControl]="form.get('terms_and_conditions')">
              <ppl-checkbox formControlName="terms_and_conditions">
                <span i18n="@@I_have_read_and_agreed_to_the">I have read and agreed to the</span>
                <span>&nbsp;</span>
                <a i18n="@@General_Terms_and_Conditions"
                   class="link"
                   target="_blank"
                   href="https://www.pipelinersales.com/terms/">General Terms and Conditions</a>
              </ppl-checkbox>
            </ppl-input-container>
          </ppl-form-column>
        </ppl-form-row>

      </ppl-form-container>

      <div class="buttons">
        <button pplButton
                pplButton2
                i18n="@@Save_&_Continue"
                (click)="onSaveAndContinue()">Save & Continue</button>
      </div>

      <ppl-loading-overlay *ngIf="saving$ | async"
                           [large]="true"
                           [visible]="true"
                           [inverse]="true"></ppl-loading-overlay>
    </ppl-box-container-with-header>
  </div>
</ppl-app-container>
